import axios from 'axios';

// Single multi-tenant backend. Base URL comes from the build-time env var; an empty value means
// same-origin (the dashboard is served behind the same nginx that proxies /api to the backend).
// For local dev, set REACT_APP_API_BASE_URL=http://localhost:5080 in .env.local.
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || '',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

export { apiClient };
